import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { usePopper } from "react-popper";

const StatusDropdown = (
  {
    placement = "bottom-end",
    offset = [0],
    btnClassName,
    button,
    options = [],
    onOptionSelect,
    children,
    onChange,
    disabled,
  },
  forwardedRef
) => {
  const [visibility, setVisibility] = useState(false);

  const referenceRef = useRef();
  const popperRef = useRef();

  const { styles, attributes } = usePopper(
    referenceRef.current,
    popperRef.current,
    {
      placement,
      modifiers: [
        {
          name: "offset",
          options: {
            offset,
          },
        },
      ],
    }
  );

  const handleDocumentClick = (event) => {
    if (
      referenceRef.current?.contains(event.target) ||
      popperRef.current?.contains(event.target)
    ) {
      return;
    }

    setVisibility(false);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleDocumentClick);
    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
    };
  }, []);

  useImperativeHandle(forwardedRef, () => ({
    close() {
      setVisibility(false);
    },
  }));
  const handleButtonClick = () => {
    if (!disabled) {
      setVisibility(!visibility);
    }
  };
  return (
    <>
      <button
        ref={referenceRef}
        onChange={onChange}
        disabled={disabled}
        type="button"
        className={btnClassName}
        // className={`${btnClassName} ${
        //   disabled ? "opacity-50 cursor-not-allowed" : ""
        // }`}
        onClick={() => setVisibility(!visibility)}
        // onClick={handleButtonClick}
      >
        {button}
      </button>

      <div
        ref={popperRef}
        style={styles.popper}
        {...attributes.popper}
        className="z-50 max-h-[300px] border-b-2"
        onClick={(e) => e.stopPropagation()}
      >
        {visibility && (
          <ul className="">
            {options.map((option) => (
              <li key={option.value}>
                <button
                  type="button"
                  onClick={() => {
                    onOptionSelect(option);
                    setVisibility(false);
                  }}
                >
                  {option.label}
                </button>
              </li>
            ))}
            {children}
          </ul>
        )}
      </div>
    </>
  );
};

export default forwardRef(StatusDropdown);
